import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SkeletonModule } from 'primeng/skeleton';

import { UplayButtonComponent } from '@usheru-hff/core/uplay-button';
import { MovieTellFriendsComponent } from '@usheru-hff/movie-detail/ui-movie-elements';
import { SharedUiPictureModule } from '@usheru-hff/shared/ui-picture';
import { VideoComponent } from '@usheru-hff/shared/ui-video';
import { SharedUtilsModule } from '@usheru-hff/shared/utils';
import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';

import { VideoThumbnailComponent } from './video-thumbnail/video-thumbnail.component';

@NgModule({
  imports: [
    CommonModule,
    VideoComponent,

    MovieTellFriendsComponent,
    FontAwesomeModule,
    SharedUiPictureModule,
    SharedUtilsImageModule,
    SharedUtilsModule,
    UplayButtonComponent,
    SkeletonModule,
    RouterModule.forChild([])
  ],
  declarations: [VideoThumbnailComponent],
  exports: [VideoThumbnailComponent]
})
export class SharedFeatureVideoThumbnailModule {}
